// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QA-Rn","newExpiryDate":"styles_newExpiryDate__2Fvko","footer":"styles_footer__2qCAM"};